const ANDATA = "A";
const RITORNO = "R";

// TODO: lettura dati da server
export {
    ANDATA, RITORNO
}